import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

import SpecialText from '../fragments/SpecialText';

export default function Benefits({ block }) {

    const benefitsRevealRef = useReveal({ once: true });

    const heading_maximum_width = block.heading_maximum_width ? block.heading_maximum_width + 'em' : '30em';

    return (
        <div id={block.section_id} className={`c-page__block c-page__block--benefits`}>
            <div className={`l-grid c-transition-in`} ref={benefitsRevealRef}>
                <div className={`l-grid__col l-grid__col--m-5-12 l-grid__col--l-6-12`}>
                    {block.heading && (
                        <h2 className="c-benefits__heading c-heading c-heading--accent" style={{ maxWidth: heading_maximum_width }}>
                            <SpecialText text={block.heading || 'Benefits'} />
                        </h2>
                    )}
                    {block.subheading && (
                        <p className="c-heading c-benefits__introduction l-bottom-space" style={{ maxWidth: heading_maximum_width }}>
                            <SpecialText text={block.subheading || ''} />
                        </p>
                    )}
                </div>
                <div className={`l-grid__col l-grid__col--m-7-12 l-grid__col--l-6-12`}>
                    {block.benefits && block.benefits.length > 0 && (
                        <ul className="c-benefits__list">
                            {block.benefits.map((benefit, index) => (
                                <li className="c-benefits__list__item" key={index}>
                                    <h3 className="c-benefits__list__item__heading c-paragraph c-paragraph--medium c-paragraph--accent">
                                        <SpecialText text={benefit.heading || ''} />
                                    </h3>
                                    {benefit.text && (
                                        <div className="c-benefits__list__item__text scope-text" dangerouslySetInnerHTML={{ __html: benefit.text }} />
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );

}